import { useState } from 'react';
import GOAL_EDIT_MODAL from './goal-edit-modal';
import { goalProgress } from './goal-form';

export default function ScheduledGoalList({ goals, refreshGoals, readOnly = false }) {
  const [editingGoal, setEditingGoal] = useState(null);
  return <>
    <ul className="scheduled-goals">
      {(goals || []).filter(Boolean).map(goal => <li key={goal._id}>
        <span className="scheduled-goals__name">{goal.name}</span>
        <span className={`goal-progress status-${goal.status}`}>{goal.status === 'completed' ? 'Complete' : goal.status === 'in-progress' ? 'In Progress' : 'Not Started'} · {goalProgress(goal)}%</span>
        {!readOnly && <button type="button" className="btn-outline pill" aria-label={`Edit ${goal.name}`} onClick={() => setEditingGoal(goal)}>Edit</button>}
      </li>)}
    </ul>
    {!readOnly && <GOAL_EDIT_MODAL isOpen={!!editingGoal} onClose={() => setEditingGoal(null)} goal={editingGoal} getUserGoals={refreshGoals} />}
  </>;
}
